import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVisaProfessionChnagesData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FinListVisaProfessionChanges from "./FinListVisaProfessionChanges";

export default function FinVisaProfessionChanges() {
  const visaData = useSelector((state) => state.visaProfessionChnages);
  const dispatch = useDispatch();

  //screen Title Show fun
  const titleBorder = [
    {
      label: "Visa Profession Changes fee",
      link: "/dashboard/VisProfessionChanges",
    },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getVisaProfessionChnagesData(token));
  }, []);
  const callApi = () => {
    dispatch(getVisaProfessionChnagesData(token));
  };
  return (
    <>
      <div className={`ml-5 mr-5`}>
        <FinListVisaProfessionChanges
          list={visaData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE Name",
            "Client",
            "Visa Provider",
            "IQAMA Number",
            "PassPort Number",
            "IQAMA Profession",
            "Current Profession level",
            "Application Date",
            "New Visa Profession",
            "New Visa Profession level",
            // "New Visa Provider",
            "BORNE BY",
            "NITAKAT+ADMIN+SL",
            "IQAMA PROFESSION CHANGE FEE",
            "INVOICE DATE",
            "INVOICE RECEIVED AMOUNT",
            "DONE DATE",
            "EFFECTIVE DATE",
            "STATUS",
            "Action",
          ]}
          token={token}
          updateData={callApi}
        />
      </div>
    </>
  );
}
